import React from 'react';
import { ListItemIcon as MuiListItemIcon, ListItemIconProps as MuiListItemIconProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface ListItemIconProps extends MuiListItemIconProps {
  spacing?: number;
}

const useStyles = makeStyles<ListItemIconProps>()((theme, props) => ({
  root: {
    minWidth: theme.spacing(props.spacing + 3),
  },
}));

type TypeMap<D extends React.ElementType = 'div'> = {
  props: ListItemIconProps;
  defaultComponent: D;
  classKey: string;
};

const ListItemIcon: React.FC<React.PropsWithChildren<ListItemIconProps>> = (props) => {
  const { classes } = useStyles(props, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    props,
  });
  return <MuiListItemIcon {...(props as any)} classes={classes} />;
};

export default ListItemIcon as OverridableComponent<TypeMap>;
